// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MovieList_wrapper__kAZ_c"};